import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AppActivity extends Component {
    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Saas/App/AppBrowser")
    }

    render() {
        return (
            <Activity 
                name="App"
                RenderedComponent={this.RenderedComponent}
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AppActivity)
